import { initializeApp, getApps } from 'firebase/app';
import { getFirestore, doc, getDoc } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];
const firestore = getFirestore(app);

export type FirestoreResponse<T> = {
  data: T | null;
  error: string | null;
};

export const getDocumentById = async <T>(
  collectionPath: string,
  documentId: string,
): Promise<FirestoreResponse<T>> => {
  try {
    const documentSnapshot = await getDoc(doc(firestore, collectionPath, documentId));

    if (documentSnapshot.exists()) {
      return {
        data: { id: documentSnapshot.id, ...documentSnapshot.data() } as T,
        error: null,
      };
    }

    return { data: null, error: 'Document not found' };
  } catch (error) {
    return {
      data: null,
      error: error instanceof Error ? error.message : 'Unknown error occurred',
    };
  }
};

export { firestore };
